import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import * as l18n from './assets/languages/zh.json'
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: '/web/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      alias: '/home',
      meta: {
        title: 'home',
        l18ntitle: 'home',
        keepAlive: true,
        showAllNav: true,
        all: true
      }
    },
    {
      path: '/custom',
      name: 'custom',
      component: () => import(/* webpackChunkName: "custom" */ './views/Custom.vue'),
      meta: {
        headHide: true,
        showAllNav: true,
        footHide: true,
        title: 'Sanlida Archery',
        l18ntitle: 'custom',
      }
    },

    {
      path: '/share',
      name: 'share',
      component: () => import(/* webpackChunkName: "custom" */ './views/Share.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: 'Sanlida Archery',
        l18ntitle: 'custom',
      }
    },

    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "login" */ './views/Register.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: 'register',
        l18ntitle: 'register',
      }
    },
		
		{
		  path: '/forgot',
		  name: 'forgot',
		  component: () => import(/* webpackChunkName: "login" */ './views/Forgot.vue'),
		  meta: {
		    headHide: true,
		    footHide: true,
		    title: 'forgot',
		    l18ntitle: 'forgot',
		  }
		},

    {
      path: '/frame',
      name: 'frame',
      component: () => import(/* webpackChunkName: "center" */ './views/Frame.vue'),
      meta: {
        headHide: false,
        footHide: false,
      }
    },


    {
      path: '/author',
      name: 'author',
      component: () => import(/* webpackChunkName: "login" */ './views/author.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: 'authorization',
        l18ntitle: 'authorization',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      meta: {
        headHide: true,
        footHide: true,
        title: 'login',
        l18ntitle: 'login'
      }
    },
    {
      path: '/search',
      name: 'search',
      component: () => import(/* webpackChunkName: "product" */ './views/SearchResult.vue'),
      meta: {
        title: '搜索结果',
        l18ntitle: 'searchResult',
        keepAlive: true,
        showAllNav: true
      }
    },
    {
      path: '/detail/:goodsId/:invite?',
      name: 'detail',
      component: () => import(/* webpackChunkName: "product" */ './views/ProductDetail.vue'),
      meta: {
        title: '商品详情',
        l18ntitle: 'detail',
        keepAlive: true
      }
    },
    {
      path: '/buySuccess',
      name: 'buySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/BuySuccess.vue'),
      meta: {
        title: '成功加入购物车',
        l18ntitle: 'addedToCartSuccessfully'
      }
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: () => import(/* webpackChunkName: "product" */ './views/PaySuccess.vue'),
      meta: {
        title: '支付成功',
        l18ntitle: 'paySucess'
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/MyCart.vue'),
      meta: {
        title: '我的购物车',
        l18ntitle: 'myCart',
        headHide: true,
      }
    },
    {
      path: '/ywhz',
      name: 'ywhz',
      component: () => import(/* webpackChunkName: "cart" */ './views/ywhz/index.vue'),
      meta: {
        title: '业务合作',
        l18ntitle: 'cooperation',
        showAllNav: false
      }
    },
    {
      path: '/article',
      name: 'article',
      redirect: '/article/index',
      component: () => import(/* webpackChunkName: "cart" */ './views/article/index.vue'),
      meta: {
        title: '新闻中心',
        l18ntitle: 'news'
      },
      children: [
        {
          path: 'index',
          name: 'articleIndex',
          component: () => import(/* webpackChunkName: "center" */ './views/article/list.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        },
        {
          path: 'detail',
          name: 'articledetail',
          component: () => import(/* webpackChunkName: "center" */ './views/article/detail.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        },
      ]
    },



    {
      path: '/video',
      name: "video",
      component: () =>  import('./views/video/index.vue'),
      meta: {
        title: '视频',
        l18ntitle: 'video',
        showAllNav: true
      },
    },

    {
      path: '/videodetail/:videoId',
      name: 'videodetail',
      component: () =>  import('./views/video/detail.vue'),
      meta: {
        title: '视频',
        l18ntitle: 'video',
        showAllNav: false
      },
    },

    {
      path: '/videoclassify',
      name: 'videoclassify',
      component: () =>  import('./views/video/classify.vue'),
      meta: {
        title: '视频分类',
        l18ntitle: 'video',
        showAllNav: true
      },
    },



    {
      path: '/arrows',
      name: 'arrows',
      redirect: '/arrows/index',
      component: () => import('./views/arrows/index.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',
        showAllNav: false
      },
      children: [
        {
          path: 'index',
          name: 'Index',
          component: () => import('./views/arrows/list.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        }
      ]
    },

    {
      path: '/arrowsapply',
      name: 'arrowsapply',
      component: () => import(/* webpackChunkName: "center" */ './views/arrows/apply.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',
      },
    },
	
    {
      path: '/arrowsdetail',
      name: 'arrowsdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/arrows/detail.vue'),
      meta: {
        title: '射箭场馆',
        l18ntitle: 'arrow',


      },
    },
	
	
    {
      path: '/picture',
      name: 'picture',
      redirect: '/picture/index',
      component: () => import('./views/picture/index.vue'),
      meta: {
        title: '照片墙',
        l18ntitle: 'picture',
        showAllNav: false
      },
      children: [
        {
          path: 'index',
          name: 'pictureIndex',
          component: () => import('./views/picture/list.vue'),
          meta: {
            title: '',
            keepAlive: false,
            showAllNav: false
          },
        }
      ]
    },
	
    {
      path: '/picturedetail',
      name: 'picturedetail',
      component: () => import(/* webpackChunkName: "center" */ './views/picture/detail.vue'),
      meta: {
        title: '照片墙详情',
        l18ntitle: 'picture',
      },
    },
	
    {
      path: '/order',
      name: 'order',
      component: () => import(/* webpackChunkName: "cart" */ './views/Order.vue'),
      meta: {
        headHide: true,
        l18ntitle: 'information'
      }
    },
    {
      path: '/center',
      name: 'center',
      component: () => import(/* webpackChunkName: "center" */ './views/Center/Index.vue'),
      redirect: { name: 'User' },
      meta: {
        footShow: true
      },
      children: [
        {
          path: 'user',
          name: 'User',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/User.vue'),
          meta: {
            title: '我的个人中心',
            l18ntitle: 'myCenter',
            keepAlive: false
          },
        },
        
        {
          path: 'favourite',
          name: 'favourite',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Favourite.vue'),
          meta: {
            title: l18n.collection, // 我的收藏
            l18ntitle: 'collection'
          },
        },

        {
          path: 'arrows',
          name: 'arrows',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Arrow.vue'),
          meta: {
            title: '箭馆',
            l18ntitle: 'arrow'
          },
        },
        {
          path: 'footmark',
          name: 'footmark',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/FootMark.vue'),
          meta: {
            title: '我的足迹',
            l18ntitle: 'footprint'
          },
        },
        {
          path: 'balance',
          name: 'balance',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Balance.vue'),
          meta: {
            title: '我的余额',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'recharge',
          name: 'recharge',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Recharge.vue'),
          meta: {
            title: '余额充值',
            l18ntitle: 'balance'
          },
        },


        {
          path: 'distribution',
          name: 'distribution',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/distributionMe.vue'),
          meta: {
            title: '分销中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'distributionClient',
          name: 'distributionClient',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/distributionClient.vue'),
          meta: {
            title: '分销中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'channel',
          name: 'channel',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channelMe.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'channelApply',
          name: 'channelApply',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/apply.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staff',
          name: 'staff',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staff.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'goods',
          name: 'goods',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/goods.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'staffwithdrawal',
          name: 'staffwithdrawal',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffwithdrawal.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staffadd',
          name: 'staffadd',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffadd.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'staffshare',
          name: 'staffshare',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/staffshare.vue'),
          meta: {
            title: '渠道中心',
            l18ntitle: 'balance'
          },
        },
        {
          path: 'stafforder',
          name: 'stafforder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channel/stafforder.vue'),
          meta: {
            title: '员工订单',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'withdrawCash',
          name: 'withdrawCash',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/withdrawCash.vue'),
          meta: {
            title: '申请提现',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'bank',
          name: 'bank',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/bank.vue'),
          meta: {
            title: '申请提现',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'ali',
          name: 'ali',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/ali.vue'),
          meta: {
            title: '支付宝管理',
            l18ntitle: 'balance'
          },
        },

        {
          path: 'channelclient',
          name: 'channelclient',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/channelClient.vue'),
          meta: {
            title: '渠道中心员工',
            l18ntitle: 'balance'
          },
        },
        
        {
          path: 'myOrder',
          name: 'myOrder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/MyOrder.vue'),
          meta: {
            title: '我的订单',
            l18ntitle: 'myOrder'
            
          },
        },
        {
          path: 'orderDetail/:order_id',
          name: 'orderDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/OrderDetail.vue'),
          meta: {
            title: '订单详情',
            l18ntitle: 'myOrder'
          }
        },
        {
          path: 'userInfo',
          name: 'userInfo',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/UserInfo.vue'),
          meta: {
            title: '资料设置',
            l18ntitle: 'setting'
          }
        },
        {
          path: 'safeCenter',
          name: 'safeCenter',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/SafeCenter.vue'),
          meta: {
            title: '安全中心',
            l18ntitle: 'securityCenter'
          }
        },
        {
          path: 'address',
          name: 'address',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Address.vue'),
          meta: {
            title: '收货地址',
            l18ntitle: 'shippingAddress'
          }
        },
        {
          path: 'point',
          name: 'point',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Point.vue'),
          meta: {
            title: '我的X币',
            l18ntitle: 'integral'
          }
        },
        {
          path: 'coupon',
          name: 'coupon',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Coupon.vue'),
          meta: {
            title: '我的优惠券',
            l18ntitle: 'coupon'
          }
        },
        {
          path: 'receipt',
          name: 'receipt',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Receipt.vue'),
          meta: {
            title: '我的发票',
            l18ntitle: 'invoic'
          }
        },
        {
          path: 'videoorder',
          name: 'videoorder',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/videoorder.vue'),
          meta: {
            title: '视频订单',
            l18ntitle: 'videoorder'
          }
        },
        {
          path: 'refund',
          name: 'refund',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/Index.vue'),
          meta: {
            title: '申请退换货',
            l18ntitle: 'applyForAfterSales'
          },
        },
        {
          path: 'refundDetail/:aftersales_id',
          name: 'refundDetail',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundDetail.vue'),
          meta: {
            title: '退换货详情',
            l18ntitle: 'detail'
          }
        },
        {
          path: 'refundApply/:order_id',
          name: 'refundApply',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Refund/RefundApply.vue'),
          meta: {
            title: '退换货申请',
            l18ntitle: 'applyForAfterSales'
          }
        },
        {
          path: 'evaluate',
          name: 'evaluate',
          component: () => import(/* webpackChunkName: "center" */ './views/Center/Evaluate.vue'),
          meta: {
            title: '评价订单',
            l18ntitle: 'evaluate'
          }
        }
      ]
    },
    {
      path: '/help',
      name: 'help',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/Index.vue'),
      meta: {
        footShow: true
      }
    },
    {
      path: '/helpdetail',
      name: 'helpdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/Help/detail.vue'),
      meta: {
        footShow: true
      }
    },

    {
      path: '/books',
      name: 'books',
      component: () => import(/* webpackChunkName: "center" */ './views/Books/Index.vue'),
      meta: {
        footShow: true
      }
    },

    

    {
      path: '/bookdetail',
      name: 'bookdetail',
      component: () => import(/* webpackChunkName: "center" */ './views/Books/detail.vue'),
      meta: {
        footShow: true
      }
    },
	

    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "center" */ './views/contact/index.vue'),
      meta: {
        title: '关于我们',
        l18ntitle: 'Contact Us',
        headHide: false,
        showAllNav: true,
        footHide: false,
      }
    },

    {
      path: '/cashier/:order_id/:type?',
      name: 'cashier',
      component: () => import(/* webpackChunkName: "center" */ './views/Cashier.vue'),
      meta: {
        title: '收银台',
        l18ntitle: 'settlementList',
        headHide: true,
      },
    },
		{
		  path: '/jump',
		  name: 'jump',
		  component: () => import(/* webpackChunkName: "center" */ './views/jump.vue'),
		  meta: {
		    footShow: true
		  }
		},
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // if (savedPosition) {
    //   return savedPosition
    // } else {
      return { x: 0, y: 0 }
    // }

  }
})

